export const en = {
    access: 'Access rights',
    cancel: 'Cancel',
    save: 'Save'
};
